/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useState } from 'react';

import { Popover } from '@coursera/cds-core';

import NotificationIcon from 'bundles/notification-center/components/NotificationIcon';
import NotificationListView from 'bundles/notification-center/components/NotificationListView';
import NotificationCenterDataProvider from 'bundles/notification-center/components/data/NotificationCenterDataProvider';
import UserExperienceContextProvider from 'bundles/unified-common/providers/UserExperienceContextProvider';

const styles = {
  popoverBody: css`
    max-width: 400px;
  `,
};

const NotificationCenter = () => {
  const [popoverAnchor, setPopoverAnchor] = useState<null | HTMLButtonElement>(null);
  const isOpen = Boolean(popoverAnchor);
  const toggleActive = (e: React.MouseEvent<HTMLButtonElement>) => {
    setPopoverAnchor(e.currentTarget);
  };

  return (
    <UserExperienceContextProvider>
      <NotificationCenterDataProvider>
        {({ loading, error, refetch, notifications, markNotificationAsRead, markAllNotificationsAsRead }) => {
          if (loading || error || !notifications) {
            return (
              <div>
                <NotificationIcon unreadCount={0} onClick={(e) => toggleActive(e)} />
              </div>
            );
          }

          const unreadCount = notifications?.filter((notification) => {
            if (notification.messageType === 'PartnerIncentiveMessage') {
              return false;
            }
            return !notification.isRead;
          }).length;

          return (
            <div>
              <NotificationIcon unreadCount={unreadCount} onClick={toggleActive} isOpen={isOpen} />
              <Popover
                open={isOpen}
                anchorElement={popoverAnchor}
                onClose={() => setPopoverAnchor(null)}
                drawerProps={{ autoFocus: false }}
              >
                <Popover.Body tabIndex={0} css={styles.popoverBody}>
                  <NotificationListView
                    unreadCount={unreadCount}
                    notifications={notifications}
                    refetchNotifications={refetch}
                    markNotificationAsRead={markNotificationAsRead}
                    markAllNotificationsAsRead={markAllNotificationsAsRead}
                  />
                </Popover.Body>
              </Popover>
            </div>
          );
        }}
      </NotificationCenterDataProvider>
    </UserExperienceContextProvider>
  );
};

export default NotificationCenter;
